import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import EditAccount from '../../../../styles/images/edit-account.png';
import BusinessAccount from '../../../../styles/images/business-accounts.png';
import ContactUs from '../../../../styles/images/contact-us.png';
import Exit from '../../../../styles/images/exit.png';
import HowPay from '../../../../styles/images/how-pay.png';
import Rules from '../../../../styles/images/rules.png';
import ArkLogo from '../../../../styles/images/ark-logo.png';
import Swal from 'sweetalert2';
import axios from "axios";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { actionLogOutUser } from '../../../../redux/actions/pages/user/user';
import { BASE_SITE, USERS_LOGOUT_GET } from '../../../../apis'; 


const MenuItem = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token } = useSelector(state => state.user);
    const { isOpen } = useSelector(state => state.bottom_sheet);

    const handleLogout = () => {
        if(! isOpen) {
            const buttonsOkCancel = Swal.mixin({
                customClass: {
                    confirmButton: 'primary-btn primary-border font-weight-300 radius-12  py-2  ml-3 width-80',
                    cancelButton: 'primary-border primary-txt-color font-weight-300 radius-12  py-2 width-80',
                },
                buttonsStyling: false
            });

            buttonsOkCancel.fire({
                text: "آیا میخواهید از حساب کاربری خود خارج شوید؟",
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(handleSetBackdropLoading(true));
                    axios({
                        method: 'get',
                        url: BASE_SITE + USERS_LOGOUT_GET,
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': token
                        },
                    }).then((response) => {
                        switch (response.data.status) {
                            case 'error':
                                dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                                break;
                            case 'ok':
                                dispatch(actionLogOutUser());


                                navigate('..');
                                break;
                            default:
                                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                        }
                        dispatch(handleSetBackdropLoading(false));
                    }, () => {
                        dispatch(handleSetBackdropLoading(false));
                        dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    });
                }
            }); 
        }
    };

    const checkBottomSheetIsOpen = (event) => {
        if(isOpen)
            event.preventDefault();
    };

    return (

        <div id="user-menu-item" className="mt-4">
            {!!token ?
            <Row className="py-3 mx-3" style={{borderTop: "unset"}}>
                <Col xs={12} className="text-left px-0" >
                    <Link to="../edit_profile" onClick={checkBottomSheetIsOpen}>
                        <img src={EditAccount} width={20} className="mr-3" alt="ویرایش حساب کاربری" />
                        ویرایش حساب کاربری
                    </Link>
                </Col>
            </Row>
            :''}

            <Row className="py-3 mx-3">
                <Col xs={12} className="text-left px-0" >
                    <Link to="../tutorial">
                        <img src={HowPay} width={20} className="mr-3" alt="روش های پرداخت" />
                        روش های پرداخت
                    </Link>
                </Col>
            </Row>

            <Row className="py-3 mx-3">
                <Col xs={12} className="text-left px-0" >
                    <Link to="../rules">
                        <img src={Rules} width={20} className="mr-3" alt="قوانین و مقررات" />
                        قوانین و مقررات
                    </Link>
                </Col>
            </Row>

            <Row className="py-3 mx-3">
                <Col xs={12} className="text-left px-0" >
                    <Link to="../support">
                        <img src={ContactUs} width={20} className="mr-3" alt="تماس با پشتیبانی" />
                        تماس با پشتیبانی
                    </Link>
                </Col>
            </Row>

            <Row className="py-3 mx-3">
                <Col xs={12} className="text-left px-0" >
                    <Link>
                        <img src={BusinessAccount} width={20} className="mr-3" alt="ورود به پروفایل کسب و کار" />
                        ورود به پروفایل کسب و کار
                    </Link>
                </Col>
            </Row>

            {!!token ?
            <Row className="py-3 mx-3">
                <Col xs={12} className="text-left px-0" onClick={handleLogout}>
                    <Link>
                        <img src={Exit} width={20} className="mr-3" alt="خروج" />
                        خروج
                    </Link>
                </Col>
            </Row>
            :''}

            <Row className="py-3 mx-3">
                <Col xs={12} className="text-left px-0" >
                    <a href="https://4rk.ir" title="طراحی اپلیکیشن موبایل | طراحی وبسایت" target="_blank" rel="noreferrer">
                        
                        <img src={ArkLogo} width={20} className="mr-3" alt="ورود به پروفایل کسب و کار" />
                        طراحی توسط گروه برنامه نویسی آرک
                    </a>
                </Col>
            </Row>
            
        </div>

    );
}

export default MenuItem;